// extracted by mini-css-extract-plugin
module.exports = {"updatesIntro":"UpdatesIntro-module--updatesIntro--2Fnju"};